export const LocationOfObject = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M12.7352 3.78412L16.1977 3.77467V7.2324M16.1977 12.7723V16.2324H12.7352M7.19529 3.76759L3.73285 3.77467V7.2324M3.73285 12.7723V16.2324H7.19529M0.962891 19V1.00471L18.9676 1V19H0.962891Z"
                stroke="#838280" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}